import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full xl:w-1/2 xl:pr-3" }
const _hoisted_2 = { class: "w-full xl:w-1/2 xl:pl-3" }


export default /*@__PURE__*/_defineComponent({
  __name: 'TwoColumn',
  props: {
    disabled : {
        type: Boolean,
        default: false
    }
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row flex-wrap mb-6", {'pointer-events-none':__props.disabled}])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "left")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "right")
    ])
  ], 2))
}
}

})